<template>
  <section class="flex flex-col gap-200 rounded-m bg-secondary-secondary p-200">
    <h2 v-if="$slots.headline" class="paragraph-bold">
      <slot name="headline" />
    </h2>

    <slot />
  </section>
</template>
